import debug from 'debug'

const log = debug('xpedeo-core:history')
debug.enable(process.env.VUE_APP_DEBUG)

export default {
  __homePages: [],
  __nextPageId: null,
  __historyArray: [],
  __router: null,
  __lastPanoramaPageId: null,
  __lastPanoramaHomePageId: null,
  __$xp: null,
  // @deprecated
  get homePageId () {
    if (this.__homePages.length) {
      return this.__homePages[this.__homePages.length - 1].id
    }
    return null
  },
  // @deprecated
  get previousHomePageId () {
    if (this.__homePages.length > 1) {
      return this.__homePages[this.__homePages.length - 2].id
    }
    return null
  },
  // @deprecated
  get homePage () {
    if (this.__homePages.length) {
      return this.__homePages[this.__homePages.length - 1]
    }
    return null
  },
  // @deprecated
  get previousHomePage () {
    if (this.__homePages.length > 1) {
      return this.__homePages[this.__homePages.length - 2]
    }
    return null
  },
  get lastHomePage () {
    if (this.__homePages[this.__homePages.length - 1]) {
      if (
        this.__homePages[this.__homePages.length - 1].id === this.__$xp.content.pageData.ID || // if we are in the last saved home page
        (
          this.__$xp.content.pageData.Homepage &&
          this.__homePages[this.__homePages.length - 1].id === Number(this.__$xp.content.pageData.Homepage.ID)
        ) // in case we are in a page that already renders the last saved home page tabs
      ) {
        return this.__homePages[this.__homePages.length - 2]
      } else {
        return this.__homePages[this.__homePages.length - 1]
      }
    }
  },
  get nextPageId () {
    return this.__nextPageId || null
  },
  get historyArray () {
    return this.__historyArray
  },
  get historyParams () {
    return this.__historyArray.length > 0 ? this.__historyArray[this.__historyArray.length - 1].params : {}
  },

  set nextPageId (id) {
    this.__nextPageId = id
  },

  setLastPanoramaPage (panoramaPageId, homePageId) {
    this.__lastPanoramaPageId = panoramaPageId
    this.__lastPanoramaHomePageId = homePageId
  },

  getLastPanoramaPage (homePageId) {
    return this.__lastPanoramaHomePageId === homePageId ? this.__lastPanoramaPageId : null
  },

  resetHistoryState () {
    this.__homePages = []
    this.__nextPageId = null
    this.__historyArray = []
  },
  addHomePage (pageId, pagePath, pageTitle, parentId) {
    log(`addHomePage(${pageId}, ${pagePath}, ${pageTitle}, ${parentId})`)
    pageId = parseInt(pageId)
    parentId = parseInt(parentId)
    const searchIndex = this.__homePages.findIndex(item => item.id === pageId)
    if (searchIndex > -1) {
      this.__homePages = this.__homePages.slice(0, searchIndex)
    }
    if (parentId && this.__homePages.length > 1) {
      if (parentId === this.__homePages[this.__homePages.length - 1].parentId) {
        this.__homePages.pop()
      }
    }
    this.__homePages.push({
      id: pageId,
      path: pagePath,
      title: pageTitle,
      parentId: parentId
    })
    log('Result::', { __homePages: this.__homePages })
  },
  push (newPageId, newPath) {
    const savedHistory = JSON.parse(window.localStorage.getItem('history'))
    const searchIndex = this.__historyArray.findIndex(item => item.pageId === parseInt(newPageId))

    if (savedHistory && this.__historyArray.length === 0 && savedHistory.length > 1 && savedHistory[savedHistory.length - 1].pageId === newPageId) {
      // History ist leer und in Storage ist eine History der aktuellen Seite (Seite neu geladen)
      log('History aus localStorage genommen')
      this.__historyArray = savedHistory
      this.__homePages = JSON.parse(window.localStorage.getItem('homepages'))
    } else if (searchIndex > 0) { // Seite ist bereits in der History
      if (searchIndex < this.__historyArray.length) {
        this.__historyArray = this.__historyArray.slice(0, searchIndex + 1)
      }
    } else { // Seite hinzufügen
      this.__historyArray.push({
        pageId: parseInt(newPageId),
        path: newPath,
        params: {}
      })
    }
    window.localStorage.setItem('history', JSON.stringify(this.__historyArray))
    window.localStorage.setItem('homepages', JSON.stringify(this.__homePages))
  },
  replace (newPageId, newPath) {
    this.__historyArray.splice(-1, 1)
    this.push(newPageId, newPath)
  },
  setHistoryParam (pageId, key, value) {
    pageId = parseInt(pageId)
    if (this.__historyArray.length > 0) {
      if (this.__historyArray[this.__historyArray.length - 1].pageId === pageId) {
        this.__historyArray[this.__historyArray.length - 1].params = Object.assign(
          {},
          this.__historyArray[this.__historyArray.length - 1].params,
          { [key]: value })
      } else {
        console.warn(`setHistoryParam: ${key} = ${value}. pageId does not match the last element in the history array \n ${pageId} was passed and ${this.__historyArray[this.__historyArray.length - 1].pageId} was found`)
      }
    }
  },
  back (replace) {
    if (this.__historyArray.length > 1) {
      const lastPagePath = this.__historyArray[this.__historyArray.length - 2].path
      // commit('BACK')
      this.__historyArray.splice(-1, 1)
      this.__router.push({ path: lastPagePath, query: { back: true }, replace })
    }
  },
  goHome (replace) {
    if (this.lastHomePage) {
      log('GO HOME: (previous)' + this.lastHomePage.path)
      this.__router.push({ path: this.lastHomePage.path, replace })
    } else {
      log('GO START')
      this.__router.push({ path: '/', replace })
    }
  },
  saveHistoryState () {
    log('Saving history state')
    window.localStorage.setItem('HomePages', JSON.stringify(this.__homePages))
    window.localStorage.setItem('nextPageId', this.__nextPageId)
    window.localStorage.setItem('historyArray', JSON.stringify(this.__historyArray))
  },
  restoreHistoryState () {
    log('Restoring history state')
    this.__homePages = JSON.parse(window.localStorage.getItem('HomePages'))
    window.localStorage.setItem('HomePages', '')

    const storedNextPageId = window.localStorage.getItem('nextPageId')
    this.__nextPageId = storedNextPageId ? Number(storedNextPageId) : null
    window.localStorage.setItem('nextPageId', '')

    this.__historyArray = JSON.parse(window.localStorage.getItem('historyArray'))
    window.localStorage.setItem('historyArray', '')
  },
  install (Vue, opts, $xp) {
    if ($xp.historyInstalled) { return }
    this.__$xp = $xp
    if (!opts.router) {
      throw new Error('History plugin needs router to initialize')
    }
    this.__router = opts.router
    $xp.historyInstalled = true
    Vue.util.defineReactive($xp, 'history', this)
  }
}
